import { Link } from "react-router-dom";
import { AppShell } from "@/components/shared/AppShell";
import { ArrowRight } from "lucide-react";

const QUICK_TOPICS = ["Newton's First Law", "Photosynthesis", "Quadratic Equations", "Cell Division"];

export function DashboardPage() {
  return (
    <AppShell>
      <h1 className="font-display text-2xl font-semibold sm:text-3xl">Dashboard</h1>
      <p className="mt-2 max-w-lg font-body text-sm text-ink/60">
        Pick up where you left off, or start a new lesson — the teacher takes it from there.
      </p>

      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {QUICK_TOPICS.map((topic) => (
          <Link
            key={topic}
            to={`/classroom?topic=${encodeURIComponent(topic)}`}
            className="glass flex items-center justify-between rounded-2xl p-5 transition-transform hover:-translate-y-0.5"
          >
            <span className="font-body text-sm font-medium">{topic}</span>
            <ArrowRight size={16} className="text-marker" />
          </Link>
        ))}
      </div>

      <Link
        to="/classroom"
        className="mt-6 inline-block rounded-xl bg-ink px-5 py-2.5 font-body text-sm text-paper"
      >
        Choose your own topic
      </Link>
    </AppShell>
  );
}
